import { useState, type ReactNode } from 'react'
import {
  QueryClient,
  QueryClientProvider,
  QueryCache,
  MutationCache,
} from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { logger } from '@/lib/logger'

export function QueryProvider({
  children,
}: {
  readonly children: ReactNode
}) {
  const [client] = useState(
    () =>
      new QueryClient({
        queryCache: new QueryCache({
          onError(error, query) {
            logger.error('Query failed', {
              err: error,
              queryKey: query.queryKey as unknown as string,
            })
          },
        }),
        mutationCache: new MutationCache({
          onError(error, _variables, _context, mutation) {
            logger.error('Mutation failed', {
              err: error,
              mutationKey: mutation.options.mutationKey as unknown as string,
            })
          },
        }),
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            retry: 1,
            refetchOnWindowFocus: false,
          },
        },
      })
  )

  return (
    <QueryClientProvider client={client}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}
